import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { states } from '../data/BusinessType';
import {businesses} from "../data/BusinessType"
import {FaChevronUp, FaChevronDown} from 'react-icons/fa';
import Navbar from './Navbar';
import axios from 'axios';
import './BusinessAdminProfile.css';
import { Link } from 'react-router-dom';
import BusinessLogin from './BusinessLogin';
import { FaMapMarkerAlt, FaTrash, FaPlus, FaHome, FaCog } from 'react-icons/fa';

const BusinessAdminProfile = () => {
  const { adminBusiness, businessAdminToken, fetchBusinessAdmin } = useAuth();
  const [branchMessage, setBranchMessage] = useState(null);
  const [message, setMessage] = useState(null);
  const [newBranchContainer, setNewBranchContainer] = useState(false);
  const [numberOfBranches, setNumberOfBranches] = useState(0);


  const [newBranch, setNewBranch] = useState({
    name: '',
    street: '',
    houseNumber: '',
    city: '',
    postalCode: '',
    country: 'Česko',
  });
  const [newBusiness, setNewBusiness] = useState({
    owner: '',
    businessType: "",
    ic: '',
    dic: '',
    phone: '',
    email: '',
    password: '',
    name: '',
    street: '',
    houseNumber: '',
    city: '',
    postalCode: '',
    country: 'Česko',
  });
  const [openedOverlayBranchId, setOpenedOverlayBranchId] = useState(null);

  useEffect(() => {
    fetchBusinessAdmin();
  }, [fetchBusinessAdmin]);



  const DataChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewBranch((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const [isOpen, setIsOpen] = useState({});  // objekt kde klíčem je index nebo id pobočky

  const handleOpen = (index) => {
    setIsOpen(prev => ({
      ...prev,
      [index]: !prev[index],  // přepnutí na opačný stav (toggle)
    }));
  };

  const formSubmit = async (e) => {
    e.preventDefault();
  
    if (!businessAdminToken) return;
  
    // POZOR na překlep: 'lenght' -> správně 'length'
    if (adminBusiness.branches.length >= 3) {
      const confirmExtra = window.confirm(
        "Překročení limitu.\nPřidáním této nové bude k měsíčnímu předplatnému připočteno 99 Kč pro další měsíc a za dobu užívání zpětně v další faktuře, poté bude pokračovat podle plánu.\nPřejete si pokračovat?"
      );
      if (!confirmExtra) return; // uživatel kliknul na "Zrušit"
    }
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/create-branch`,
        newBranch,
        {
          headers: {
            Authorization: `Bearer ${businessAdminToken}`,
          },
        }
      );
      setBranchMessage(response.data.message);
    } catch (err) {
      setBranchMessage(err.response?.data?.message);
    } finally {
      setTimeout(() => {
        setBranchMessage(null);
        setNewBranch({
          name: '',
          street: '',
          houseNumber: '',
          city: '',
          postalCode: '',
          country: 'Česko',
        })
        fetchBusinessAdmin();
      }, 2000);
    }
  };

  const handleOpenOverlay = (branchId) => {
    setOpenedOverlayBranchId(branchId);
  };

  const handleCloseOverlay = () => {
    setOpenedOverlayBranchId(null);
  };

  const changeBusinessInput = (e) => {
    const { name, value } = e.target;
    setNewBusiness((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formNewBusiness = async (e, item) => {
    e.preventDefault();


    const { name, street, houseNumber, city, postalCode, country } = item;

    const businessData = {
      ...newBusiness,
      name,
      street,
      houseNumber,
      city,
      postalCode,
      country,
      branchId: item._id,
      businessAdminId: adminBusiness._id
    };

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/create-employee`,
        businessData,
        {
          headers: {
            Authorization: `Bearer ${businessAdminToken}`,
          },
        }
      );
      console.log(response.data)
      setMessage('Přidání uživatele úspěšné');
      setNewBusiness({
        owner: '',
        ic: '',
        dic: '',
        phone: '',
        businessType: "",
        email: '',
        password: '',
        name: '',
        street: '',
        houseNumber: '',
        city: '',
        postalCode: '',
        country: 'Česko',
        branchId: "",
      });
    } catch (err) {
      setMessage(err.response?.data?.message || 'Něco se pokazilo');
    } finally {
        setTimeout(() => {
            setMessage(null)
            fetchBusinessAdmin()
        }, 2000)
    }
  };

  const handleDeleteBranch = async (id) => {
    if (adminBusiness && businessAdminToken) {
      try {
        const confirmExtra = window.confirm(
          "Odstraněním pobočky odstraníte veškeré údaje spojené s touto pobočkou.\nOdstraněním vám budou vráceny peníze za dobu, za jakou byla pobočka již odstraněna při další faktuře\nPřejete si pokračovat?"
        );
        if (!confirmExtra) return; // uživatel kliknul na "Zrušit"

        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/business/delete-branch`,
          {
            headers: {
              Authorization: `Bearer ${businessAdminToken}`,
            },
            data: {
              id,
              businessAdminId: adminBusiness._id,
            },
          }
        );
        setBranchMessage(response.data.message);
      } catch (err) {
        setBranchMessage(err.response?.data?.message);
      } finally {
        setTimeout(() => {
          setBranchMessage(null);
          fetchBusinessAdmin(); // obnova dat
          setNewBranchContainer(false);
        }, 2000);
      }
    }
  };
  const handleDeleteBusiness = async (id) => {
    if (adminBusiness && businessAdminToken) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/business/delete-branch-business`,
          {
            headers: {
              Authorization: `Bearer ${businessAdminToken}`,
            },
            data: {
              id,
            },
          }
        );
        setBranchMessage(response.data.message);
      } catch (err) {
        setBranchMessage(err.response?.data?.message);
      } finally {
        setTimeout(() => {
          setBranchMessage(null);
          fetchBusinessAdmin(); // obnova dat
        }, 2000);
      }
    }
  }

  useEffect(() => {
    if (adminBusiness && adminBusiness.branches) {
      setNumberOfBranches(adminBusiness.branches.length);
    }
  }, [adminBusiness]);



  // dashboard data
  const totalBusiness = adminBusiness?.branches?.reduce((acc, branch) => {
    return acc + (branch.businesses ? branch.businesses.length : 0)
  }, 0)


  if (!businessAdminToken && !adminBusiness) {
    return <div className='min-height'>
      <BusinessLogin />
    </div>
  }

  return (
    <div className="min-height">
      <Navbar />
      <div className="adminbusiness-right">
  <div className="adminbusiness-form-and-branches">
    {/* Formulář pro přidání pobočky */}
    <div className="adminbusiness-branch-form">
      
      {newBranchContainer && <div className="adminbusiness-branch-form-container">
      <form className="login-form" onSubmit={formSubmit}>
        <input type="text" placeholder="Jméno pobočky" name="name" value={newBranch.name} onChange={DataChange} required className="login-input" />
        <input type="text" placeholder="Město" name="city" value={newBranch.city} onChange={DataChange} required className="login-input" />
        <input type="text" placeholder="Ulice" name="street" value={newBranch.street} onChange={DataChange} required className="login-input" />
        <input type="text" placeholder="Číslo popisné" name="houseNumber" value={newBranch.houseNumber} onChange={DataChange} required className="login-input" />
        <input type="text" placeholder="PSČ" name="postalCode" value={newBranch.postalCode} onChange={DataChange} required className="login-input" />
        <select name="country" value={newBranch.country} onChange={DataChange} required className="login-input">
          {states.map((state, index) => (
            <option key={index} value={state.name}>{state.name}</option>
          ))}
        </select>
        <button  type="submit" className="login-button">Přidat pobočku</button>
      </form>
      {branchMessage && <p className="message">{branchMessage}</p>}
      </div>}
    </div>

    {/* Výpis poboček */}
    <div className='adminbusiness-branch-add-buttons'>
      {newBranchContainer ? <button className="login-button" onClick={() => setNewBranchContainer(false)}>Zpět</button> : <button className='add-branch-button' onClick={() => setNewBranchContainer(true)}>Přidat pobočku</button>}
    </div>
    {(newBranchContainer === false || newBranchContainer === "false") && numberOfBranches > 0 ? <div className="adminbusiness-branches-list">
         <div className="dashboard-percent-container">
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h3>Profily</h3>
              
            </div>
            <h2 className="dashboard-value">{totalBusiness}</h2>

          </div>
        
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h3>Pobočky</h3>
              
            </div>
            <h2 className="dashboard-value">{numberOfBranches}</h2>

          </div>
        
        </div>
        <div className='adminbusiness-branches-list-container'>
      {adminBusiness?.branches?.map((item, index) => (
        <div key={item._id} className="branch-container">
          <div 
            className="branch-header advantage-text-showup" 
            onClick={() => handleOpen(index)}
            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <div className='branch-header-text'>
              <h2>{item.name} <button className='button-none' onClick={() => handleDeleteBranch(item._id)}><FaTrash size={20} color='#f39c12' /></button></h2>
              <p><FaMapMarkerAlt size={12} color="white" /> {item.street} {item.houseNumber}, {item.city} {item.postalCode}</p>
            </div>
            {isOpen[index] ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          {isOpen[index] && (
            <div className="branch-details">
              {item.businesses?.map((business) => (
                <div key={business._id} className="employee-row" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div>
                    <p>{business.owner}</p>
                  </div>
                  <div className='admin-profile-buttons-second'>
                  <Link className="button-none" to={`/business/admin-profile/${business._id}`}><FaCog size={19} color='#2460a1' /></Link>
                    <Link className="button-none" to={`/business/public/${business._id}`}><FaHome  size={21} color='#2460a1' /></Link>
                    <button className="button-none" onClick={() => handleDeleteBusiness(business._id)}><FaTrash size={18} color='red' /></button>
                  </div>
                </div>
              ))}

              <div className='zeromargin admin-profile-buttons'>
              <button className='button-none' onClick={() => handleOpenOverlay(item._id)}>
                <FaPlus size={20} color='white' background='none' />
              </button>
  
              </div>
              {/* Overlay */}
              <div className={`admin-overlay ${openedOverlayBranchId === item._id ? 'active' : ''}`} onClick={handleCloseOverlay}>
                <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
                  <span className="admin-overlay-close" onClick={handleCloseOverlay}>&times;</span>
                  <h3>Přidat profil do {item.name}</h3>
                  <form onSubmit={(e) => formNewBusiness(e, item)}>
                    <input type="text" name="owner" value={newBusiness.owner} onChange={changeBusinessInput} placeholder="Jméno a příjmení" className="login-input" required />
                    <select name="businessType" value={newBusiness.businessType} onChange={changeBusinessInput} className="login-input" required>
                      <option value="" disabled>Vyberte druh podnikání</option>
                      {businesses.map((response, idx) => (
                        <option key={idx} value={response}>{response}</option>
                      ))}
                    </select>
                    <input type="text" name="ic" value={newBusiness.ic} onChange={changeBusinessInput} placeholder="IČ (nepovinné)" className="login-input" />
                    <input type="text" name="dic" value={newBusiness.dic} onChange={changeBusinessInput} placeholder="DIČ (nepovinné)" className="login-input" />
                    <input type="number" name="phone" value={newBusiness.phone} onChange={changeBusinessInput} placeholder="Telefon" className="login-input" required />
                    <input type="email" name="email" value={newBusiness.email} onChange={changeBusinessInput} placeholder="Email" className="login-input" required />
                    <input type="password" name="password" value={newBusiness.password} onChange={changeBusinessInput} placeholder="Heslo" className="login-input" required />
                    <button type="submit" className="login-button">Přidat profil</button>
                    {message && <p className="message">{message}</p>}
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
    </div> : newBranchContainer ? <div></div> : <div className='no-branch-text'><h3>Žádné pobočky</h3></div>}
  </div>
</div>
    </div>
  );
};

export default BusinessAdminProfile